import { WidgetProps } from "@rjsf/utils";

import { SelectGmnTable } from "@/features/overview";

// Custom GMN selector widget for BrostarForm
export const GmnSelectTable = ({ value, onChange }: WidgetProps) => {
  return <SelectGmnTable defaultSelectedBroIds={value || []} receiveSelectedBroIds={onChange} />;
};
